
    <template>
      <section class="content element-doc">
        <h2>TableFilter 搜索条件</h2>
<p>用于table表格上方的搜索条件组</p>
<h3>基础用法</h3>
<p>基础的全部为input输入框用法</p>
<demo-block>
        <div><p><code>type</code>对应类型，<code>label</code>对应标题，<code>value</code>对应字段名。示例如下：</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-filter :query.sync=&quot;filterInfo.query&quot; :filter-list=&quot;filterInfo.list&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      filterInfo: {
        query: {
          pol: '',
          pod: ''
        },
        list: [
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' }
        ]
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>有下拉框</h3>
<p>有输入框和下拉框的用法</p>
<demo-block>
        <div><p>通过<code>listTypeInfo</code>属性设置下拉框中option，也可以直接设置<code>list</code>数组，<code>list</code>也可以是一个函数</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-filter :query.sync=&quot;filterInfo.query&quot; :filter-list=&quot;filterInfo.list&quot; :list-type-info=&quot;listTypeInfo&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: [
            { key: 'HOLD', value: 1 },
            { key: 'NORMAL', value: 2 }
          ] },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date' },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime' },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList' },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo' },
          { type: 'input', label: 'Warehouse', value: 'warehouse' },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo' }
        ]
      },
      // 相关列表
      listTypeInfo: {
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>混合型</h3>
<p>有输入框、下拉框、混合型输入框多种混合的用法</p>
<demo-block>
        <div><p>通过设置<code>type</code>属性为<code>mixin</code>开启混合型输入框</p>
</div>
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-filter :query.sync=&quot;filterInfo.query&quot; :filter-list=&quot;filterInfo.list&quot; :list-type-info=&quot;listTypeInfo&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      filterInfo: {
        query: {
          searchNoType: '',
          searchNo: '',
          holdStatus: '',
          pol: '',
          pod: ''
        },
        list: [
          { type: 'mixin', label: 'Search No', value: 'searchNo', selectValue: 'searchNoType', list: 'searchNoTypeList' },
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' }
        ]
      },
      // 相关列表
      listTypeInfo: {
        searchNoTypeList: [
          { key: 'house #', value: 1 },
          { key: 'master #', value: 2 }
        ],
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ]
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>自定义组件</h3>
<p>Apex-UI预定义的组件不满足时，可传入使用自定义组件</p>
<demo-block>
        <div><p>设置<code>type</code>为<code>custom</code>开启自定义组件。设置<code>component</code>对象的<code>name</code>传入自定义组件来进行渲染，如果是<a href="https://cn.vuejs.org/v2/guide/components-registration.html#%E5%85%A8%E5%B1%80%E6%B3%A8%E5%86%8C">全局注册</a>的自定义组件，只需传入组件名即可；如果是<a href="https://cn.vuejs.org/v2/guide/components-registration.html#%E5%B1%80%E9%83%A8%E6%B3%A8%E5%86%8C">局部注册</a>的组件，则需要传入<code>import</code>的那个组件对象。自定义组件的写法需要符合<a href="https://cn.vuejs.org/v2/guide/components-custom-events.html#%E8%87%AA%E5%AE%9A%E4%B9%89%E7%BB%84%E4%BB%B6%E7%9A%84-v-model">自定义组件使用v-model</a>的写法，可以在<code>component</code>中传入<code>props</code>字段，传入的字段可以在自定义组件中通过<code>props</code>接收，自定义组件还可以通过在<code>props</code>中定义<code>scope</code>字段来拿到当前行的所有数据。</p>
</div>
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-filter :query.sync=&quot;filterInfo.query&quot; :filter-list=&quot;filterInfo.list&quot; :list-type-info=&quot;listTypeInfo&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          custom: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'custom', label: '自定义组件', value: 'custom',
            component: {
              name: 'apex-tree-select',
              props: {
                clearable: true,
                filterable: true,
                defaultExpandAll: true,
                popperAppendToBody: true,
                size: 'small',
                props: {
                  label: 'title'
                },
                data: [
                  {
                    title: &quot;我的账户&quot;,
                    id: 869,
                    pid: 868,
                    children: [
                      {
                        id: 877,
                        pid: 869,
                        title: &quot;账户概览&quot;,
                        children: [
                          {
                            id: 878,
                            pid: 877,
                            title: &quot;账户提现(账户信息)&quot;,
                          }
                        ]
                      }
                    ]
                  },
                  {
                    title: &quot;公司&quot;,
                    id: 1,
                    pid: 0,
                    children: [
                      {
                        id: 2,
                        pid: 1,
                        title: &quot;部门&quot;,
                        children: [
                          {
                            id: 3,
                            pid: 2,
                            title: &quot;小组&quot;
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            }
          }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ]
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>可展开收起搜索条件</h3>
<p>当表格搜索条件过多时可开启该功能</p>
<demo-block>
        <div><p>设置<code>filter-list</code>里的<code>fold</code>属性设置为<code>true</code>可开启该功能，把此项收到折叠条件里。示例如下：</p>
</div>
        <template slot="source"><element-demo4 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-filter labelWidth=&quot;80px&quot; :query.sync=&quot;filterInfo.query&quot; :filter-list=&quot;filterInfo.list&quot; :list-type-info=&quot;listTypeInfo&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date', fold: true },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime', fold: true },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList', fold: true },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo', fold: true },
          { type: 'input', label: 'Warehouse', value: 'warehouse', fold: true },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo', fold: true }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ],
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><div class="warning">
<p>当遇到控制台报如下错时：
<code>[Vue warn]: Error in beforeDestroy hook: &quot;Error: [ElementForm]unpected width &quot;</code>。
把 apex-filter 的<code>labelWidth</code>属性给一个固定值，即可解决该问题。如下代码示例。</p>
</div>
<h3>默认展开所有搜索条件</h3>
<p>默认展开</p>
<demo-block>
        <div><p>通过设置<code>expandedAll</code>属性可默认展开所有折叠的搜索条件。</p>
</div>
        <template slot="source"><element-demo5 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-filter 
  expanded-all 
  label-width=&quot;80px&quot; 
  :query.sync=&quot;filterInfo.query&quot; 
  :filter-list=&quot;filterInfo.list&quot; 
  :list-type-info=&quot;listTypeInfo&quot; 
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date', fold: true },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime', fold: true },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList', fold: true },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo', fold: true },
          { type: 'input', label: 'Warehouse', value: 'warehouse', fold: true },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo', fold: true }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ],
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>apex-filter Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>query</td>
<td>查询参数，支持 .sync 修饰符</td>
<td>object</td>
<td>—</td>
<td>{}</td>
</tr>
<tr>
<td>filter-list</td>
<td>过滤器列表</td>
<td>array</td>
<td>—</td>
<td>[]</td>
</tr>
<tr>
<td>list-type-info</td>
<td>相关列表</td>
<td>object</td>
<td>—</td>
<td>{}</td>
</tr>
<tr>
<td>className</td>
<td>自定义类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>size</td>
<td>表单大小</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>labelWidth</td>
<td>表单域标签的的宽度，例如 '50px'。支持 auto。</td>
<td>string</td>
<td>—</td>
<td>auto</td>
</tr>
</tbody>
</table>
<h3>filter-list Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>类型</td>
<td>string</td>
<td>input / select / mixin / time / date</td>
<td>—</td>
</tr>
<tr>
<td>label</td>
<td>label文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value</td>
<td>query对应的字段名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>selectValue</td>
<td>type为 mixin 时下拉框值对应的字段名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>list</td>
<td>type为 select 或 mixin 时下拉框options对应的数组名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>show</td>
<td>是否显示</td>
<td>boolean</td>
<td>true/false</td>
<td>true</td>
</tr>
<tr>
<td>fold</td>
<td>是否放到折叠条件里</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>list-type-info Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>key</td>
<td>下拉框显示文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value</td>
<td>下拉框文字对应的值</td>
<td>any</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>search</td>
<td>搜索按钮的回调</td>
<td>—</td>
</tr>
<tr>
<td>reset</td>
<td>重置按钮的回调</td>
<td>—</td>
</tr>
<tr>
<td>expandChange</td>
<td>搜索条件展开或收起状态改变回调</td>
<td>expanded</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-filter',{attrs:{"query":_vm.filterInfo.query,"filter-list":_vm.filterInfo.list},on:{"update:query":function($event){return _vm.$set(_vm.filterInfo, "query", $event)}}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      filterInfo: {
        query: {
          pol: '',
          pod: ''
        },
        list: [
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' }
        ]
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-filter',{attrs:{"query":_vm.filterInfo.query,"filter-list":_vm.filterInfo.list,"list-type-info":_vm.listTypeInfo},on:{"update:query":function($event){return _vm.$set(_vm.filterInfo, "query", $event)}}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: [
            { key: 'HOLD', value: 1 },
            { key: 'NORMAL', value: 2 }
          ] },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date' },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime' },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList' },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo' },
          { type: 'input', label: 'Warehouse', value: 'warehouse' },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo' }
        ]
      },
      // 相关列表
      listTypeInfo: {
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-filter',{attrs:{"query":_vm.filterInfo.query,"filter-list":_vm.filterInfo.list,"list-type-info":_vm.listTypeInfo},on:{"update:query":function($event){return _vm.$set(_vm.filterInfo, "query", $event)}}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      filterInfo: {
        query: {
          searchNoType: '',
          searchNo: '',
          holdStatus: '',
          pol: '',
          pod: ''
        },
        list: [
          { type: 'mixin', label: 'Search No', value: 'searchNo', selectValue: 'searchNoType', list: 'searchNoTypeList' },
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' }
        ]
      },
      // 相关列表
      listTypeInfo: {
        searchNoTypeList: [
          { key: 'house #', value: 1 },
          { key: 'master #', value: 2 }
        ],
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ]
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-filter',{attrs:{"query":_vm.filterInfo.query,"filter-list":_vm.filterInfo.list,"list-type-info":_vm.listTypeInfo},on:{"update:query":function($event){return _vm.$set(_vm.filterInfo, "query", $event)}}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          custom: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'custom', label: '自定义组件', value: 'custom',
            component: {
              name: 'apex-tree-select',
              props: {
                clearable: true,
                filterable: true,
                defaultExpandAll: true,
                popperAppendToBody: true,
                size: 'small',
                props: {
                  label: 'title'
                },
                data: [
                  {
                    title: "我的账户",
                    id: 869,
                    pid: 868,
                    children: [
                      {
                        id: 877,
                        pid: 869,
                        title: "账户概览",
                        children: [
                          {
                            id: 878,
                            pid: 877,
                            title: "账户提现(账户信息)",
                          }
                        ]
                      }
                    ]
                  },
                  {
                    title: "公司",
                    id: 1,
                    pid: 0,
                    children: [
                      {
                        id: 2,
                        pid: 1,
                        title: "部门",
                        children: [
                          {
                            id: 3,
                            pid: 2,
                            title: "小组"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            }
          }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ]
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-filter',{attrs:{"labelWidth":"80px","query":_vm.filterInfo.query,"filter-list":_vm.filterInfo.list,"list-type-info":_vm.listTypeInfo},on:{"update:query":function($event){return _vm.$set(_vm.filterInfo, "query", $event)}}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date', fold: true },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime', fold: true },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList', fold: true },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo', fold: true },
          { type: 'input', label: 'Warehouse', value: 'warehouse', fold: true },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo', fold: true }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ],
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-filter',{attrs:{"expanded-all":"","label-width":"80px","query":_vm.filterInfo.query,"filter-list":_vm.filterInfo.list,"list-type-info":_vm.listTypeInfo},on:{"update:query":function($event){return _vm.$set(_vm.filterInfo, "query", $event)}}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date', fold: true },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime', fold: true },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList', fold: true },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo', fold: true },
          { type: 'input', label: 'Warehouse', value: 'warehouse', fold: true },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo', fold: true }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ],
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  